import { trigger, transition, style, animate } from '@angular/animations';
import { Component, inject, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { ICommunicationLog } from 'app/models/communication-log/communication-log';
import { CommunicationLogService } from 'app/services/communication-log/communication-log.service';

@Component({
  selector: 'communication-logs',
  templateUrl: './communication-logs.component.html',
  styleUrls: ['./communication-logs.component.scss'],
  animations: [
    trigger('slideRight', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ])
  ]
})
export class CommunicationLogsComponent {
  @Input() entityId: number;
  @Input() entityType: string;

  public communicationLog: ICommunicationLog = {
    id: 0,
    sentDate: '',
    sentBy: '',
    recipients: '',
    subject: '',
    body: ''
  };

  public communicationService = inject(CommunicationLogService);
  public sharedService = inject(SharedService);

  public communicationLogs: ICommunicationLog[] = [];

  public logColumns: string [] = ['sentDate', 'subject', 'recipients'];
  public logSource = new MatTableDataSource<ICommunicationLog>(this.communicationLogs);
  @ViewChild('logPaginator', { static: false })
  set logPaginator(value: MatPaginator | undefined) {
    // Conditional views recreate these controls independently of data loading.
    this.logSource.paginator = value ?? null;
  }
  get logPaginator(): MatPaginator {
    return this.logSource.paginator!;
  }
  @ViewChild('logSort', { static: false })
  set logSort(value: MatSort | undefined) {
    // Conditional views recreate these controls independently of data loading.
    this.logSource.sort = value ?? null;
  }
  get logSort(): MatSort {
    return this.logSource.sort!;
  }

  ngOnInit(): void {
    this.getCommunicationLogs();
  }

  getCommunicationLogs(): void {
    this.communicationService.getCommunicationLogs(this.entityId, this.entityType).subscribe({
      next: response => this.communicationLogs = response,
      error: error => {
        this.sharedService.toastr.error('Failed to get communication logs');
        console.error('error getting comm logs', error);
      },
      complete: () => this.updateLogTable()
    });
  }

  updateLogTable(): void {
    this.logSource.data = this.communicationLogs;
  }

  selectLog(log: ICommunicationLog): void {
    this.communicationLog = log;
  }

  closeLog(): void {
    this.communicationLog = {
      id: 0,
      sentDate: '',
      sentBy: '',
      recipients: '',
      subject: '',
      body: ''
    };
    setTimeout(() => {
      this.updateLogTable();
    }, 500);
  }
}
